import { Hint } from "react-ui";
import * as React from "react";

import { Icon } from "../../Icons/Icon";

import { CalendarInfoCard, TextInCard } from "./FormInfo.styles";
import { htmlWithLinkToTextOrNode } from "./ActualInfoAboutForm";
import { bannerMaxWidth } from "./LinkInfo";

export interface CalendarInfoProps {
    text: string;
}

export const CalendarInfo = ({ text }: CalendarInfoProps) => {
    const splitText = text.split("|");

    return (
        <Hint
            text={htmlWithLinkToTextOrNode(splitText?.[1] ? <div>{splitText?.[1]}</div> : "")}
            pos={"bottom left"}
            maxWidth={bannerMaxWidth}
            useWrapper={true}>
            <CalendarInfoCard>
                <Icon name={"CalendarIcon"} />
                <TextInCard>{splitText?.[0]}</TextInCard>
            </CalendarInfoCard>
        </Hint>
    );
};
